import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {NzModalService, TransferItem} from 'ng-zorro-antd';
import {Subject} from 'rxjs';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {DistributorsService} from "../../../services";
import {DocumentsService} from "../../../services/business/documents/documents.service";

@Component({
  selector: 'update-title-distributors',
  templateUrl: './update-title.component.html',
  styleUrls: ['./update-title.component.scss']
})
export class UpdateTitleComponent implements OnInit {
  isVisible = false;
  actions = [
    {label: 'Gán sản phẩm', value: 0},
    {label: 'Gỡ sản phẩm', value: 1},
    {label: 'Export', value: 2},
    {label: 'Export tất cả', value: 3},
  ];
  // tslint:disable-next-line:variable-name
  // form_step1: FormGroup = this.fb.group({
  //   name: [null, [Validators.required]],
  //   title: [null, [Validators.required]],
  // });
  current = 0;
  index = 1;
  name;
  title;
  radioValue = 'A';
  confirmType = 1;
  list: TransferItem[] = [];
  // disabled = false;
  showSearch = true;
  searchPlaceholder = 'Tên hoặc mã sản phẩm';
  itemsUnit = 'Sản phẩm';
  pageIndex = 1;
  pageSize = 5;
  document = null;
  // tslint:disable-next-line:variable-name
  form_step: FormGroup = this.fb.group({
    title: [null, [Validators.required]],
    role: [null, [Validators.required]],
  });
  detailProduct;
  listRole;
  listTitle;
  productId;
  @Output() loadDataParent = new EventEmitter();
  @Input() businessIdChild: string;
  notDocuments = false;
  files: any[] = [];
  isLoadingBtn = false;

  // @ts-ignore
  @ViewChild('selectDocument') selectDocument;
  // @ts-ignore
  @ViewChild('create') create;

  constructor(
    private fb: FormBuilder,
    private modalService: NzModalService,
    private notification: NzNotificationService,
    private distributorsService: DistributorsService,
    private docService: DocumentsService,
  ) {
  }

  ngOnInit() {
    this.notification.config({
      nzPlacement: 'bottomRight'
    });

  }

  select(ret: {}): void {
    // console.log('nzSelectChange', ret);
  }

  change(ret: {}): void {
    // console.log('nzChange', ret);
  }

  handleCancel(): void {
    this.isVisible = false;
    this.files = null;
    this.form_step.reset();
  }

  showModal(data, productId): void {
    this.isVisible = true;

    this.productId = productId;
    // this.detailProduct = data;
    this.form_step.get('title').setValue(data.titleId);
    this.form_step.get('role').setValue(data.roleCode);

    const listDocument = [];
    data.documents.map((res) => {
      listDocument.push({
        documentId: res.id,
        title: res.title
      });
    });


    this.files = listDocument;

    this.distributorsService.listRole().subscribe((res) => {
      this.listRole = res.data;
    });
    this.distributorsService.listTitle({roleCode: data.roleCode}).subscribe((res) => {
      this.listTitle = res.data;
    });
  }

  onSubmit() {
    const recursive = (f: FormGroup | FormArray) => {
      // tslint:disable-next-line:forin
      for (const i in f.controls) {
        if (typeof f.controls[i].value === 'string') {
          if (f.controls[i].value.trim().length === 0) {
            f.controls[i].value = null;
          }
        }
        if (f.controls[i] instanceof FormControl) {
          f.controls[i].markAsDirty();
          f.controls[i].updateValueAndValidity();
        } else {
          recursive(f.controls[i] as any);
        }
      }
    };

    const form = this.form_step;
    recursive(form);

    if (form.invalid) {
      return;
    }

    if (this.files.length === 0) {
      this.notDocuments = true;
      return;
    }

    const docs = [];
    this.files.map(item => {
      docs.push(item.documentId);
    });

    const body = {
      titleId: this.form_step.get('title').value,
      documents: docs,
      productId: this.productId,
      businessId: this.businessIdChild,
      roleCode: this.form_step.get('role').value
    };
    this.isLoadingBtn = true;

    this.distributorsService.updateProduct(body).subscribe((res) => {
      if (res.code === 1) {
        this.notification.create(
          'success',
          'Thành công',
          'Sửa sản phẩm thành công'
        );
        this.loadDataParent.emit(true);
        this.isLoadingBtn = false;
        this.handleCancel();
      } else {

        this.notification.create(
          'warning',
          'Cảnh báo',
          res.message
        );
      }
    }, (err) => {
      this.notification.create(
        'error',
        'Thất bại',
        err
      );
      this.isLoadingBtn = false;

    });

  }


  roleChange($event: any) {
    this.listTitle = null;
    this.form_step.get('title').setValue(null);
    if ($event) {
      this.distributorsService.listTitle({roleCode: $event}).subscribe((res) => {
        this.listTitle = res.data;
      });
    }
  }


  /*document*/
  newDocument(event) {

    this.docService.create(event).subscribe(
      res => {
        if (res.code === 1) {
          this.create.hide();
          this.files.push(res.data);
          this.notDocuments = false;
          this.files.map((item) => {
            this.selectDocument.setId(item.documentId, true);
          });
          this.notification.create(
            'success',
            'Thêm giấy tờ thành công',
            res.message
          );
        } else {
          this.notification.create(
            'error',
            'Thêm giấy tờ thất bại',
            res.message
          );
        }
      },
      error => {
        this.notification.create(
          'error',
          'Thêm giấy tờ thất bại',
          error
        );
      }
    );
  }

  delete(file, index) {
    this.selectDocument.setId(this.files[index].documentId, false);
    this.files.splice(index, 1);
    if (!this.files.length) {
      this.notDocuments = true;
    }
  }

  modalDocument() {
    this.selectDocument.setCheckboxAll();
    this.files.map((res) => {
      this.selectDocument.setId(res.documentId, true);
    });
    this.selectDocument.showModal();
  }

  selectDocuments(event) {
    this.notDocuments = event.ids.length === 0;
    const newList = [];
    event.ids.map((item, key) => {
      const data = {
        documentId: item,
        title: event.titles[key]
      };
      newList.push(data);
    });
    this.files = newList;
    this.selectDocument.handleCancel();

  }

  /*End document*/

}
